import moment from 'moment'
export const changeDateFormat = (date, format) => {
  return moment(date).format(format)
}
